module.exports = __webpack_public_path__ + "static/Award2-bb57acd26c3d04da8885d7c8f65645a8.png";